// Ordered settings sections. Each becomes a "Step 0X" tab on the Settings page.
export const SETTINGS_ITEMS = [
  { slug: "accounting", label: "Accounting", caret: true },
  { slug: "beneficiaries", label: "Beneficiaries" },
  { slug: "custom-items", label: "Custom Items" },
  { slug: "eft", label: "EFT" },
  { slug: "employee-numbers", label: "Employee Numbers" },
  { slug: "employer-details", label: "Employer Details" },
  { slug: "employer-filing-details", label: "Employer Filing Details" },
  { slug: "job-grades", label: "Job Grades" },
  { slug: "leave", label: "Leave" },
  { slug: "pay-points", label: "Pay Points" },
  { slug: "pay-frequencies", label: "Pay Frequencies" },
  { slug: "payroll-calculations", label: "Payroll Calculations", caret: true },
  { slug: "payslip", label: "Payslip" },
  { slug: "templates", label: "Templates" },
  { slug: "advanced", label: "Advanced", caret: true },
];

export const stepLabel = (index) => `Step ${String(index + 1).padStart(2, "0")}`;
